export default __webpack_public_path__ + "static/media/certs-3.ea116934.jpg";